import React from 'react';

const Blogs = () => {
    return (
        <div>
            <h2>Comming soon...</h2>
        </div>
    );
};

export default Blogs;